"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("./getErrorMessageNoProjectIdFoundInApp"));
/**
 * Why?: Because the processor could not have a projectId and some callables use projectId
 * to access db as in a path for example, so to not repeat the same code on each callable
 * a function is created
 */
const getEnsuredProjectIdFromProcessor = (callerName, processor) => {
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        throw new Error((0, getErrorMessageNoProjectIdFoundInApp_1.default)(callerName));
    }
    return projectId;
};
exports.default = getEnsuredProjectIdFromProcessor;
